const $ = window.$;
const toastr = window.toastr;

import { reset_buttons } from 'form_helpers';

"use strict";

var ReorderLabs = {
  init: function() {
    $( '#lab_tree_order' ).jstree( {
      core:    {
        animation: 0,
        multiple: false,
        themes: {
          responsive: false,
          stripes: true
        },
        check_callback: true
      },
      plugins: [ 'dnd', 'search', 'types', 'unique' ],
      types: {
        default: {
          max_depth: 2,
          icon: 'fa fa-folder'
        },
        lab: {
          valid_children: [],
          icon: '/img/theme/icons/icon-lab.svg'
        },
      },
    } ).on( 'move_node.jstree', function(){
      $( '.order-by-group .btn.dropdown-toggle' ).val( 'Custom' ).html( 'Custom' );
    } );

    $( '#lab_tree_order' ).jstree( true ).open_all();

    var timeout = false;
    $( '#lab_tree_search' ).keyup( function() {
      if( timeout ){ clearTimeout( timeout ); }
      timeout = setTimeout( function() {
        var v = $( '#lab_tree_search' ).val();
        $( '#lab_tree_order' ).jstree( true ).search( v );
      }, 250 );
    } );

    $( '.action-order-by a' ).on( 'click', function( e ){
      let filterValue = $( this ).attr( 'data-filter-text' );
      if( filterValue == 'Name' ){
        sort( 'name' );
      } else if( filterValue == 'URL' ) {
        sort( 'url' );
      }
      $( this ).parents( '.dropdown' ).find( '.btn' ).html( $( this ).text() );
      $( this ).parents( '.dropdown' ).find( '.btn' ).val( $( this ).data( 'value' ) );
      e.preventDefault();
    } );

    function sort( value ) {
      let $tree = $( '#lab_tree_order' ).jstree( true ),
          data = $tree._model.data;

      Object.keys( data ).forEach( function( k ){
        let node = $tree.get_node( k ),
            new_order;
        if( node.children.length == 0 ){ return; } // no children, so skip

        new_order = node.children.sort( sort_node );
        $( '#lab_tree_order' ).jstree( 'move_node', new_order, node.id, 'last' );
      } );

      function sort_node( a, b ){
        let aa = $tree.get_node( a ),
            bb = $tree.get_node( b );

        if( aa.type == 'default' && bb.type == 'lab' ){ return -1; }
        if( aa.type == 'lab' && bb.type == 'default' ){ return 1; }
        if( aa.type == 'default' ){
          return ( aa.data.path < bb.data.path ) ? -1 : 1;
        } else { // lab
          if( value == 'name' ){
            return ( aa.text < bb.text ) ? -1 : 1;
          } else { // url
            return ( aa.data.url < bb.data.url ) ? -1 : 1;
          }
        }
      }
    }

    $( '#reorder-labs-modal .reorder_btn' ).on( 'click', function( e ){
      let $this = $( this );
      $.ajax( {
        url: '/admin/labs/sort',
        method: 'POST',
        data: { order: $( '#lab_tree_order' ).jstree( true ).get_json() },
        success: function( d ){
          if( d.error ){
            toastr.error( 'Error has occurred while sorting the labs' );
          } else {
            $( '#reorder-labs-modal' ).modal( 'hide' );
            toastr.success( d.message );
          }
          reset_buttons( $this );
        }
      } );
      e.preventDefault();
    } );
  }
};

$( function(){
  document.addEventListener( 'turbo:frame-render', async e => {
    if ( e.target.id == 'reorder-labs-template' ){
      $( '#reorder-labs-modal' ).modal( {
        focus: false
      } );
      $( '#reorder-labs-modal' ).modal( 'show' );
      ReorderLabs.init();
    }
  } );
} );
